import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import { useAssets } from "../assets/AssetsContext";

import { Link } from "react-router-dom";

function News() {
  const assets = useAssets();

  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: false,
    });
    AOS.refresh();
  }, []);

  const scrollToTop = () => {
    window.scrollTo(0, 0);
  };

  const latestnews = [
    // {
    //   id: 13,
    //   title: "Stay updated with the pulse of climate-tech innovation.",
    //   subtitle: "by admin | June 01, 2025 | Latest News",
    //   image: assets.latestthumb1a,
    //   description:
    //     "Catch the latest breakthroughs, partnerships, deployments, and leadership moves as Accel1 accelerates...",
    // },
    {
      id: 15,
      title: "Meet Our New Climate Storyteller",
      subtitle: "by accelesg | July 01, 2025 | Latest News",
      image: assets.Pratibha,
      description:
        "Introducing: Pratibha Chauhan Equestrian | Journalism & Mass Comm.| Next-Gen Climate Voice",
    },
    {
      id: 14,
      title:
        "Wendy Atlin Joins Accel1 as Chief Growth Officer to Spearhead Global Climate-Tech Growth",
      subtitle: "by accelesg | Jun 9, 2025 | Latest News",
      image: assets.wendyBanner,
      description:
        "We are thrilled to announce that Wendy Atlin has joined Accel1 as our Chief Growth Officer (CGO),..",
    },

    {
      id: 1,
      title:
        "Accel1 Announces Strategic Acquisition of RR Engineers to Strengthen Sustainable Water Solutions Portfolio",
      subtitle: "by admin | Apr 22, 2025 | Latest News",
      image: assets.latestthumb1,
      description:
        "Accel1, a global climate-tech and sustainability solutions leader, is pleased to announce the acquisition of RR...",
    },
    {
      id: 2,
      title:
        "Accel1 Launches Climate Engineering Vertical to Pioneer Sustainable Water and Climate Solutions",
      subtitle: "by admin | Apr 7, 2025 | Latest News",
      image: assets.latestthumb2,
      description:
        "Strategic Appointments of Dr. Sai Bhaskar Reddy Nakka and Shashank Taman to Lead HydroTRACE™& BioFORGE™ Platforms and...",
    },
    {
      id: 3,
      title:
        "Accel1 Launches AccelALERT: A Game-Changer in Health, Safety & Compliance",
      subtitle: "by admin | Mar 10, 2025 | Latest News",
      image: assets.latestthumb3,
      description:
        "Atlanta, 6th March 2025 – Accel1, a global leader in sustainability and ESG solutions, proudly announces the launch of..",
    },
    {
      id: 4,
      title:
        "PANA Holdings Takes a Major Step in Strengthening Its Sustainability Commitment by Signing a Multi-Year Deal with Accel1",
      subtitle: "by admin | Jan 29, 2025 | Latest News",
      image: assets.latestthumb4,
      description:
        "PANA Holdings signs deals with Accel1 to advance ESG data management and sustainability across its subsidiaries for...",
    },
    {
      id: 5,
      title:
        "AccelESG Recognized as a Major Contender in Everest Group’s ESG Data Management Platform PEAK Matrix® Assessment 2024",
      subtitle: "by admin | Nov 18, 2024 | Latest News",
      image: assets.latestthumb5,
      description:
        "ATLANTA –AccelESG, a leader in ESG (Environmental, Social, and Governance) data management and sustainability...",
    },
    {
      id: 6,
      title:
        "Zain Group selects AccelTRACK for reporting, transparency, and accountability on environmental, social, and governance (ESG) metrics.",
      subtitle: "by admin | Oct 1, 2024 | Latest News",
      image: assets.latestthumb6,
      description:
        "Zain Group, a leading provider of innovative technologies and digital lifestyle communications operating in eight...",
    },
    {
      id: 7,
      title:
        "AccelESG Welcomes Balvinder Mangat as Vice President of Delivery Excellence",
      subtitle: "by admin | Aug 19, 2024 | Latest News",
      image: assets.latestthumb7,
      description:
        "AccelESG is proud to announce the appointment of Balvinder Mangat as our new Vice President of Delivery Excellence....",
    },
    {
      id: 8,
      title: "Most Promising Technology Company Founded",
      subtitle: "by admin | Jun 16, 2024 | Latest News",
      image: assets.latestthumb8,
      description:
        "Environmental, social and governance (ESG) metrics are the compass for modern organizations, helping them attain...",
    },
    {
      id: 9,
      title:
        "Bedrock Technology Inc. and AccelESG Inc. Forge Strategic Alliance to Revolutionize Global Supply Chain Sustainability",
      subtitle: "by admin | Mar 21, 2024 | Latest News",
      image: assets.latestthumb9,
      description:
        "ATLANTA, GA, March 06, 2024 /24-7PressRelease/ -- Bedrock Technology Inc., an industry leader renowned for delivering...",
    },
    {
      id: 10,
      title: "Pioneering ESG Reporting: A New Era Unveiled with AccelTRACK",
      subtitle: "by accelesg | Feb 9, 2024 | Latest News",
      image: assets.latestthumb10,
      description:
        "ATLANTA, GA, February 05, 2024 /24-7PressRelease/ -- In a rapidly evolving business landscape, where sustainability...",
    },
  ];

  return (
    <div>
      <div className="innerbanner-section-1">
        <div className="relative-2">
          <div className="s2-heading-text">
            <h1 data-aos="zoom-in">
              Stay updated with the pulse of climate-tech innovation.
            </h1>
            <p data-aos="zoom-in">
              Catch the latest breakthroughs, partnerships, deployments, and
              leadership moves as Accel1 accelerates sustainable impact across
              regions — from Rajasthan’s farms to global boardrooms.
            </p>
          </div>
          <img
            src={assets.careerbanner}
            alt=""
            data-aos="fade-in"
            className="d-d"
          />
          <img
            src={assets.careerbanner2}
            alt=""
            data-aos="fade-in"
            className="m-d"
          />
        </div>
      </div>
      <div className="flagship-bg">
        <div className="wrapper">
          <div class="flagship-heading">
            {/* <h2>Latest Blogs</h2> */}
            {/* <p>
              From drylands to data platforms, our breakthrough initiatives
              showcase how scalable climate engineering is driving real-world
              transformation.
            </p> */}
          </div>
          <div className="blog-sec">
            {latestnews.map((news) => (
              <div key={news.id} className="blog-m-item">
                <Link to={`/news/${news.id}`} onClick={scrollToTop}>
                  <img src={news.image} alt={news.title} />
                  <div className="blog-content">
                    <h4>{news.title}</h4>
                    <h5>{news.subtitle}</h5>
                    <p>{news.description}</p>
                  </div>
                </Link>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

export default News;
